import styles from "./Resultado.module.css";
import imagem from "../../Imgs/Trabalho.png";
import {Link} from 'react-router-dom'
function Resultado() {
  return (
    <div className={styles.container}>
      <h3 id="resultados">//Produções</h3>
      <div className={styles.conteudo}>
        <img src={imagem} alt="Equipe"></img>
        <p>
        Venha conhecer o que já produzimos no contexto dos jogos para o ensino de Geografia.
        </p>
      </div>
      <div className={styles.bt}><Link to='/resultadosp'>conheça nosso material</Link></div>
      <p></p>
    </div>
  );
}
export default Resultado;
